import React, { useEffect, useState } from "react";
import { Col, Form, Row, OverlayTrigger, Tooltip, InputGroup } from "react-bootstrap";
import classNames from "classnames";
import { circleInfo } from "../../features/base64/images.constants";


const Input = ({ field, onFieldChange, data, fieldsResult }) => {
  const [type, setType] = useState(field.name === "SocialSecurityNumber"); 
  useEffect(() => {
    const value = fieldsResult[field.name] || field.defaultValue
    onFieldChange(field.name, value);
    // eslint-disable-next-line
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {field.friendlyDescription}
    </Tooltip>
  );

  return (
    <Form.Group>
      <Row className="mx-n1 mb-3">
        <Col lg={6} className="px-1">
          <Form.Label className={classNames({ required: field.required })}>
            {field.friendlyName}
            {field.friendlyDescription && <OverlayTrigger
              placement="top"
              overlay={renderTooltip}
            >
              <img className="ml-2" src={circleInfo} aria-hidden="true" x="0" y="0" height="14px" width="14px" />
            </OverlayTrigger>}
          </Form.Label>
        </Col>
        <Col lg={6} className="px-1">
        <Form.Group controlId="validationCustomUsername">
          <InputGroup hasValidation>
            {field.name === "SocialSecurityNumber" ? <InputGroup.Text id="inputGroupPrepend" onClick={() => {setType(!type)}}>{type ? <i class="fa fa-eye-slash" aria-hidden="true"></i> : <i class="fa fa-eye" aria-hidden="true"></i>}</InputGroup.Text> : ""} 
            <Form.Control
              type={type ? "password" : "text"}
              value={data[field.name]}
              onChange={(e) => onFieldChange(field.name, e.target.value)}
              required={field.required}
              maxLength={100}
          />
          </InputGroup>
        </Form.Group>
        </Col>
      </Row>
    </Form.Group>
  );
};

export default Input;
